import { Service, IWebPageService } from "./Service";
import { User as UserEntity } from "../Entity/User";
import { toMap, getAppService } from "../../../HA";

/**
 * Service utilisateur côté client.
 *
 * ha/443i : portée drastiquement réduite. Plus de fetch boot `/user/profile`
 * (l'état user vient désormais du custom element `<hauser-user-chip>` qui
 * fetche son propre `hauser.user.current` à la demande). Le login client
 * (`/user/login`) est supprimé — login = server-side `ha.login`/LoginService.
 *
 * Surface conservée :
 *   - `subscribe(func)` : encore consommé par `NavigationUser` (nav legacy).
 *     Reçoit l'état initial du User entity (vide tant que personne ne le
 *     peuple — cohérent avec « pas de fetch inconditionnel »).
 *   - `getUser()` : accès à l'entité User locale.
 *   - `process({a:"logout"|...})` : dispatch d'actions JSON. Le seul cas
 *     encore utile est `logout` (purge cookies + remove all apps + dispatch
 *     de la réponse serveur).
 */
export class User extends Service {

    public subscribe(func: (profile: any) => void): void {
        const subscribers: Map<any, any> = this.get("subscribers");
        if (subscribers) {
            const key = this.get("_subCount") || 0;
            this.addToData("_subCount", key + 1);
            subscribers.set(key, func);
            func(this.getUser().getProfileData());
        }
    }

    public getUser(): UserEntity {
        return this.get("user");
    }

    public process(data: Map<any, any>): void {
        switch (data.get("a")) {
            case "logout":  this.logout(); break;
        }
    }

    protected logout(): Promise<any> {
        return this.request(toMap({url: "/user/logout", data: {}}))
            .then((response: Map<any, any>) => {
                document.cookie.split(";").forEach((cookie) => {
                    const eqPos = cookie.indexOf("=");
                    const name  = eqPos > -1 ? cookie.slice(0, eqPos) : cookie;
                    document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT";
                });
                this.getPageService().removeAll();
                getAppService().processAction(response);
            });
    }

    protected getPageService(): IWebPageService {
        return this.getService("ha.service.webpage") as IWebPageService;
    }

    protected request(data: Map<any, any>) {
        return (this.getService("router") as any).post(data);
    }

    protected initialize(data: any): void {
        super.initialize(data);
        this.addToData("user", new UserEntity());
        this.addToData("subscribers", new Map());
    }
}
